import { createTheme } from '@mui/material'

import {
  primaryMain,
  primaryLight,
  primaryDark,
  secondaryMain,
  secondaryDark,
  whiteTextColor,
  lightOnDark,
  lightOnDark3,
  textOnWhiteBgColor,
  blackTextColor,
  chipColor,
  infoLight,
  infoDark,
  infoMain,
  disabledTextColor,
  disabledButtonBgColor,
  lightOnDark2,
} from './components/Constants'

export const theme = createTheme({
  //   cssVariables: false, // ⬅️ vypnutie CSS variables systému (zabráni ContextRegistry chybe)
  palette: {
    primary: {
      main: primaryMain,
      light: primaryLight,
      dark: primaryDark,
    },
    secondary: {
      main: secondaryMain,
      dark: secondaryDark,
    },
    success: {
      main: secondaryMain,
    },
    info: {
      main: infoMain,
      dark: infoDark,
      light: infoLight,
    },
  },
  typography: {
    fontFamily: 'Manrope', // Customize the default font family
    h1: {
      fontFamily: 'Manrope',
      fontSize: 64,
      fontWeight: 700,
      color: blackTextColor,
    },
    h2: {
      fontFamily: 'Manrope',
      fontSize: 46,
      fontWeight: 700,
      color: blackTextColor,
    },
    h3: {
      fontFamily: 'Manrope',
      fontSize: 32,
      fontWeight: 600,
      color: blackTextColor,
    },
    h4: {
      fontFamily: 'Manrope',
      fontSize: 26,
      fontWeight: 400,
      color: blackTextColor,
    },
    h5: {
      fontFamily: 'Manrope',
      fontSize: 20,
      fontWeight: 600,
      color: blackTextColor,
    },
    h6: {
      fontFamily: 'Manrope',
      fontSize: 18,
      fontWeight: 400,
      color: blackTextColor,
    },
    body1: {
      fontFamily: 'Manrope',
      fontSize: 16,
      fontWeight: 400,
      color: textOnWhiteBgColor,
    },
    body2: {
      fontFamily: 'Manrope',
      fontSize: 14,
      fontWeight: 400,
      color: textOnWhiteBgColor,
    },
  },
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          height: '1px',
          backgroundColor: lightOnDark3,
        },
      },
    },
    MuiInputAdornment: {
      styleOverrides: {
        root: {
          color: `${lightOnDark} !important`,
        },
      },
    },
    MuiInputBase: {
      variants: [
        {
          props: { size: 'medium' },
          style: {
            borderRadius: '30px !important',
            paddingLeft: '10px',
          },
        },
        {
          props: { size: 'small' },
          style: {
            borderRadius: '20px !important',
          },
        },
      ],
      styleOverrides: {
        // NOTE: setting on select from autocomplete
        input: {
          '&:-webkit-autofill': {
            WebkitTextFillColor: lightOnDark,
            transition: 'background-color 5000s ease-in-out 0s',
            transitionDelay: 'background-color 5000s',
          },
        },
        root: {
          minWidth: '30px',
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: secondaryMain,
          },
          '&.Mui-disabled': {
            color: `${disabledTextColor} !important`,
            backgroundColor: disabledButtonBgColor,
          },
        },
      },
    },
    MuiOutlinedInput: {
      variants: [
        {
          props: { size: 'medium' },
          style: {
            borderRadius: '30px !important',
          },
        },
        {
          props: { size: 'small' },
          style: {
            borderRadius: '20px !important',
          },
        },
      ],
      styleOverrides: {
        input: {
          '&:-webkit-autofill': {
            WebkitBoxShadow: '0 0 0 100px transparent inset',
          },
        },
        root: {
          '.MuiOutlinedInput-notchedOutline': {
            border: `1px solid ${lightOnDark}`,
          },
          //NOTE: this is input Hover color
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: `${secondaryMain} !important`,
          },
          //NOTE: this is input Focus color
          '&.Mui-focused fieldset': {
            border: `2px solid ${secondaryMain} !important`,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&.Mui-disabled': {
            border: `none`,
          },
        },
      },
      variants: [
        {
          props: {
            color: 'info',
          },
          style: {
            backgroundColor: '#fff',
            color: primaryMain,
            textTransform: 'none',
            fontSize: '16px',
            border: `1px solid ${primaryMain}`,
            borderRadius: '24px',
            minHeight: '48px',
            minWidth: '48px',
            paddingLeft: '25px',
            paddingRight: '25px',
          },
        },
        {
          props: {
            color: 'primary',
          },
          style: {
            backgroundColor: primaryMain,
            color: '#fff',
            textTransform: 'none',
            fontSize: '16px',
            border: `1px solid #fff`,
            borderRadius: '24px',
            minHeight: '48px',
            minWidth: '48px',
            paddingLeft: '25px',
            paddingRight: '25px',
          },
        },
        {
          props: {
            color: 'info',
            size: 'large',
          },
          style: {
            backgroundColor: '#fff',
            color: primaryMain,
            textTransform: 'none',
            fontSize: '16px',
            border: `1px solid ${primaryMain}`,
            borderRadius: '30px',
            minHeight: '60px',
            minWidth: '60px',
          },
        },
        {
          props: {
            color: 'primary',
            size: 'large',
          },
          style: {
            backgroundColor: primaryMain,
            color: '#fff',
            textTransform: 'none',
            fontSize: '16px',
            border: `1px solid #fff`,
            borderRadius: '30px',
            minHeight: '60px',
            minWidth: '60px',
          },
        },
      ],
    },
    MuiFab: {
      variants: [
        {
          props: {
            className: 'input-button',
          },
          style: {
            backgroundColor: whiteTextColor,
            textTransform: 'none',
            fontSize: '17px',
            marginRight: '-14px',
            borderRadius: '30px',
            minHeight: '56px',
            minWidth: '56px',
            paddingLeft: '30px',
            paddingRight: '30px',
          },
        },
        {
          props: {
            color: 'primary',
          },
          style: {
            backgroundColor: primaryMain,
            color: whiteTextColor,
            textTransform: 'none',
            fontSize: '16px',
            borderRadius: '24px',
            minHeight: '48px',
            minWidth: '48px',
            paddingLeft: '25px',
            paddingRight: '25px',
          },
        },
        {
          props: {
            color: 'primary',
            size: 'large',
          },
          style: {
            backgroundColor: primaryMain,
            color: whiteTextColor,
            textTransform: 'none',
            fontSize: '16px',
            borderRadius: '30px',
            minHeight: '60px',
            minWidth: '60px',
          },
        },
        {
          props: {
            color: 'secondary',
            size: 'large',
          },
          style: {
            backgroundColor: secondaryMain,
            color: blackTextColor,
            textTransform: 'none',
            fontSize: '16px !important',
            borderRadius: '30px !important',
            minHeight: '60px !important',
            minWidth: '60px !important',
          },
        },
        {
          props: {
            color: 'default',
            size: 'large',
          },
          style: {
            backgroundColor: whiteTextColor,
            color: blackTextColor,
            textTransform: 'none',
            fontSize: '16px !important',
            borderRadius: '30px !important',
            minHeight: '60px !important',
            minWidth: '60px !important',
          },
        },
        {
          props: {
            className: 'primary xl',
          },
          style: {
            backgroundColor: primaryMain,
            color: whiteTextColor,
            textTransform: 'none',
            fontSize: '16px',
            borderRadius: '40px',
            minHeight: '80px',
            minWidth: '80px',
          },
        },
        {
          props: {
            color: 'secondary',
          },
          style: {
            backgroundColor: secondaryMain,
            textTransform: 'none',
            fontSize: '16px',
            borderRadius: '24px',
            minHeight: '48px',
            minWidth: '48px',
            paddingLeft: '25px',
            paddingRight: '25px',
          },
        },
        {
          props: {
            color: 'info',
          },
          style: {
            backgroundColor: whiteTextColor,
            color: blackTextColor,
            textTransform: 'none',
            fontSize: '16px',
            borderRadius: '24px',
            minHeight: '48px',
            minWidth: '48px',
            paddingLeft: '25px',
            paddingRight: '25px',
          },
        },
        {
          props: { className: 'primary-light' },
          style: {
            backgroundColor: lightOnDark2,
            color: whiteTextColor,

            '&:hover': {
              backgroundColor: '#525e7a',
            },
          },
        },
      ],
      styleOverrides: {
        root: {
          boxShadow: 'none', // NOTE: Adjust shadow for All action buttons
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          height: '90px',
          padding: '0px !important',
        },
      },
    },
    MuiCard: {
      variants: [
        {
          props: {
            className: 'r20',
          },
          style: {
            padding: '32px',
            borderRadius: '20px',
          },
        },
        {
          props: {
            className: 'r40',
          },
          style: {
            padding: '32px',
            borderRadius: '40px',
          },
        },
      ],
      styleOverrides: {
        root: {
          padding: '35px',
          borderRadius: '32px',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          backgroundColor: chipColor,
        },
      },
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          alignItems: 'start',
          padding: 0,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: '30px',
          marginTop: '8px',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          height: '8px',
          '& .MuiSlider-track': {
            border: 'none',
          },
          '& .MuiSlider-thumb': {
            // SLIDER DOT
            height: 24,
            width: 24,
            backgroundColor: primaryMain,
            border: '3px solid #fff',
            // "&:focus, &:hover, &.Mui-active, &.Mui-focusVisible": {
            //   boxShadow: "inherit",
            // },
            '&:before': {
              display: 'none',
            },
          },
          '& .MuiSlider-valueLabel': {
            // SLIDER LABEL
            fontSize: 16,
            padding: 0,
            width: 50,
            height: 35,
            borderRadius: 20,
            backgroundColor: primaryMain,
            transform: 'translate(0%, 100%) rotate(0deg) scale(0)',
            '&.MuiSlider-valueLabelOpen': {
              transform: 'translate(0%, 100%) rotate(0deg) scale(1)',
            },
            '&:before': { display: 'none' },
          },
        },
      },
    },
  },
})
